<script lang="ts">
  import Cover from "$lib/Cover.svelte";
  import Picture from "$lib/Picture.svelte";
  import { breakpoints as br } from "$lib/utils/getBreakpoints";
  import type { ImageWithMeta } from "$lib/types/shared";

  
  

  interface Props {
    image?: ImageWithMeta | null;
    // loading is "eager" by default since CoverPicture often is above the fold
    loading?: "eager" | "lazy";
    class?: string;
    children?: import('svelte').Snippet;
  }

  let {
    image = null,
    loading = "eager",
    class: classes = "",
    children
  }: Props = $props();
</script>

{#if image?.src || children}
  <Cover
    --mt="var(--s-2)"
    --mb="var(--s-6)"
    class="min-h-[calc(5*var(--text-h-hero))] {classes}"
    pictureFallbackBackground={true}
  >
    <div
      class="pt-[calc(5*var(--text-h-hero))] pb-8 laptop:pr-[calc(12.5vw-var(--space-cover-x))] text-white flex items-end"
    >
      {@render children?.()}
    </div>

    {#snippet background()}
        <div >
        {#if image?.src}
          <Picture
            src={image.src}
            alt={image.alt || ""}
            srcset={image.srcset}
            srcsetWebp={image.srcsetWebp}
            sizes={`(min-width: ${br.desktop}) 85vw, (min-width: ${br.laptop}) 90vw, 100vw`}
            width={image?.asset?.metadata?.dimensions?.width}
            height={image?.asset?.metadata?.dimensions?.height}
            class="h-full w-full object-cover laptop:rounded-2xl"
            {loading}
          />
        {/if}
      </div>
      {/snippet}
  </Cover>
{/if}
